export default "__VITE_ASSET__52f2966b__"